<template>
  <div class="home">
    <img class="logo-page" alt="Vue logo" src="../assets/logo.png">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div v-for="(main_cat_item, key) in main_cat">
      <h2 class="menu-type__title">{{ main_cat_item.name }}</h2>
      <div v-for="(category, key) in filterByMainCat(categories, main_cat_item.id)">
        <h3 class="menu-section__title" @click.stop="toggleItemsBlock">
          <span class="exclamation" v-if="category.name=='АКЦИИ'">{{ category.name }}</span>
          <span v-else>{{ category.name }}</span>
        </h3>
        <div class="items-block">
          <div class="item" v-for="(item, key) in filterByCat(items, category.id)">   
            <div class="item-img  exmpl" v-if="item.img">
              <img @click.stop="clickImageHandler" :src="pathImgModifer(item.img)">
            </div>
            <div class="item-img exmpl" v-else><img width="300" src="/uploads/no-photo.jpg"></div>
            <div class="item-name">{{ item.name }}</div>
            <div class="item-desc">{{ item.description }} <span class="item-weight" v-if="category.name!='АКЦИИ'">({{ item.weight }})</span></div>
            <div class="item-price" v-if="category.name!='АКЦИИ'">{{ item.price }} р</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ZoomImage v-if="showZoomImage"
    :src="imageSrc"
    @close="closeZoomImage"
  />
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import HelloWorld from '@/components/HelloWorld.vue'
import ZoomImage from '../components/ZoomImage.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    ZoomImage,
  },
  data() {
    return {
      main_cat: [],
      categories: [],
      items: [],
      showZoomImage: false,
      imageSrc: '',
    }
  },
  methods: {
    getMainCat() {
      axios.get('/get-main-cat')
              .then(res=>{
                this.main_cat = res.data;
              })
              .catch(e=>{
                this.$store.dispatch('setError', e);
              })
    },
    getCategories() {
      axios.get('/get-cat')
              .then(res=>{
                this.categories = res.data
                //console.log(this.categories)
              })
              .catch(e=>{
                this.$store.dispatch('setError', e);
              })
    },
    getItems() {
      axios.get('/items/get')
              .then(res=>{
                this.items = res.data;
              })
              .catch(e=>{
                this.$store.dispatch('setError', e);
              })
    },
    filterByMainCat(arr, id) {
      return arr.filter(i=>{
        return i.main_cat_id == id
      })
    },
    filterByCat(arr, id) {
      return arr.filter(i=>{
        return i.category_id == id
      })
    },
    pathImgModifer(imgName) {
      return "/uploads/"+imgName;
    },
    clickImageHandler(e) {
      //console.log(e.currentTarget.src)
      this.imageSrc=e.currentTarget.src;
      console.log(this.imageSrc)
      this.showZoomImage = !this.showZoomImage;
    },
    closeZoomImage() {
      this.imageSrc='';
      this.showZoomImage = !this.showZoomImage;
    },
    toggleItemsBlock(e) {
      let target = e.currentTarget;
      target.nextSibling.style.display = target.nextSibling.style.display == 'flex' ? 'none' : 'flex'
    }
  },
  created() {
    this.getMainCat();
    this.getCategories();
    this.getItems();
  }
}
</script>
